/**
 * Registry of the hand-written pages.
 *
 * One list, three consumers: App.jsx routes from it, scripts/generate-sitemap.js
 * emits URLs from it, and scripts/prerender.js knows which static pages to
 * render. Adding an article here is enough to publish it everywhere.
 *
 * Plain data only. No JSX, because Node imports this file directly.
 */

/** Analysis pieces, rendered by pages/Analysis.jsx and keyed on `slug`. */
export const ANALYSES = [
  {
    slug: 'who-advertises-on-podcasts',
    title: 'Who actually advertises on podcasts',
    blurb:
      'We scanned the ad reads in every episode we have transcribed and counted which brands turn up, and on which shows.',
    description:
      'Apple Card, SimpliSafe and Squarespace dominate podcast ad reads. A count of every sponsor mention across the episodes TalkMuch has transcribed, broken down by show.',
    published: '2026-07-28',
  },
  {
    slug: 'talk-time-league-table',
    title: 'The talk-time league table',
    blurb:
      'Which hosts hold the floor and which ones get out of the way, ranked across every show we track.',
    description:
      'Host talk share across every podcast on TalkMuch, ranked. Which hosts dominate their own show, which hand the floor to their guests, and how wide the spread gets.',
    published: '2026-07-28',
  },
  {
    slug: 'interviewers-and-monologuists',
    title: 'Interviewers and monologuists',
    blurb:
      'Question ratios, turn counts and the longest uninterrupted monologues we have measured.',
    description:
      'Some hosts ask questions, some deliver lectures. Question ratio, turn switches and record monologue length across every podcast TalkMuch tracks.',
    published: '2026-07-28',
  },
];

export function findAnalysis(slug) {
  return ANALYSES.find(a => a.slug === slug) ?? null;
}

/**
 * Every hand-written route, in the order they should appear in the footer and
 * the sitemap. `standalone: true` marks pages with their own component; the
 * rest are analysis articles served by the shared Analysis page.
 */
export const EDITORIAL_ROUTES = [
  {
    path: '/about',
    title: 'About',
    standalone: true,
    description:
      'TalkMuch measures how much a podcast host talks compared with their guest. Why it exists, what we measure, and what the numbers do and do not mean.',
  },
  {
    path: '/methodology',
    title: 'Methodology',
    standalone: true,
    description:
      'How TalkMuch identifies the host in a diarized transcript, why we anchor on who reads the sponsor copy, and the limits of every measurement we publish.',
  },
  {
    path: '/contact',
    title: 'Contact',
    standalone: true,
    description: 'Get in touch with TalkMuch about a correction, a podcast request, or anything else.',
  },
  {
    path: '/privacy',
    title: 'Privacy',
    standalone: true,
    description:
      'What TalkMuch stores, which cookies we and our advertising partners set, and how to withdraw consent.',
  },
  ...ANALYSES.map(a => ({
    path: `/analysis/${a.slug}`,
    title: a.title,
    standalone: false,
    description: a.description,
  })),
];
